export default __webpack_public_path__ + "static/media/blue.88f4edf4.png";